import { NavLink } from 'react-router-dom';

export function Nav() {
  return (
    <nav className="nav">
      <NavLink
        to="/"
        end
        className={({ isActive }) =>
          `nav__link ${isActive ? 'nav__link--active' : ''}`
        }
      >
        Home
      </NavLink>
      <NavLink
        to="/music"
        end
        className={({ isActive }) =>
          `nav__link ${isActive ? 'nav__link--active' : ''}`
        }
      >
        Schedule
      </NavLink>
      <NavLink
        to="/music/contacts"
        className={({ isActive }) =>
          `nav__link ${isActive ? 'nav__link--active' : ''}`
        }
      >
        Pianists & Contacts
      </NavLink>
      <NavLink
        to="/music/admin"
        className={({ isActive }) =>
          `nav__link ${isActive ? 'nav__link--active' : ''}`
        }
      >
        Admin
      </NavLink>
    </nav>
  );
}
